const callRecordingModuleReducer = (
    state = {is_call_recording_enabled:false,is_call_recording_subscribed: false,show_call_recording_enable_option: false},
    action: {
      type: "SET_CALL_RECORDING_STATUS";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CALL_RECORDING_STATUS":
        return { ...state, ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default callRecordingModuleReducer;
  